module.exports = __webpack_public_path__ + "img/低通锐化5.4b12e9f6.png";